import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment.prod';
import { tap, catchError, map } from 'rxjs/operators';

@Injectable()
export class DataService {

    constructor(private http: HttpClient)
     { }

    title = new BehaviorSubject('');
    firstName = new BehaviorSubject('Initial');

    authToken: any;
    private refreshingToken = false;
    propertyEmitter = new Subject<any>();
    subject = new Subject<any>();
    // Fires after the signed-in subscriber saves their profile so the header can refresh the name.
    profileUpdated = new Subject<void>();
    ipAddress: any;
    private apiUrl = 'https://nominatim.openstreetmap.org/search';

    setTitle(title: string) {
        this.title.next(title);
    }
    setName(name: string) {
        this.firstName.next(name);
    }
    sendSubscriberId(subscriberId: number) {
        this.subject.next({ insertedSubscriberId: subscriberId });
    }

    getSubscriberId(): Observable<any> {
        return this.subject.asObservable();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            return of(result as T);
        };
    }

    getReportProcessingStatus(endPoint: any, body: any, token: any): Observable<any> {
        return this.http.post<any>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(
            catchError(this.handleError('Response', null))
        );
    }

    getAllUsers(endPoint: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    submitcrimedata(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getAdminUserDetails(endPoint: any, token: any, body: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSubscriberUserDetails(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getEmailSettingsDetails(endPoint: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getAdSettingsDetails(endPoint: any, token: any) {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getAdSettingsDetails1(endPoint: any, token: any) {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                Authorization: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getStates(endPoint: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAlertsDetailsPaged(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getProcessingList(endPoint: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllSubscribers(endPoint: any, token: any, body: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllDVSubscriberList(endPoint: any, token: any): Observable<any[]> {
        console.log(token);
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                Authorization: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    getDVSubscriberDetail(endPoint: any, id: any, token: any): Observable<any[]> {
        console.log(token);
        return this.http.get<any[]>(environment.dataUrl + endPoint + '/' + id, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                Authorization: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    // Data management  reports for applicants
    getAppDatamanagement(endPoint: any, applicationID: any, token: any): Observable<any[]> {
        console.log(token);
        return this.http.get<any[]>(environment.dataUrl + endPoint + '=' + applicationID, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    // Data management reports for applicants end
    getAllPropertiesList(endPoint: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getUserData(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSubscriberData(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getQualityData(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getQAPublicData(endPoint, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getReportsandServicesData(endPoint, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    createUpdateUser(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    createUpdateAdverseUser(endPoint, body, token): Observable<any[]> {

        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    updateEmailSettings(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getcrimedata(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    getapplicantreport(endPoint, body, token): Observable<any> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getAnalyticReport(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    insertcrimedata(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    submitpersonalcrimedata(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    UpdateRole(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    createSubscriberUser(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateSubscriberUsers(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to delete user
    deleteUser(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // deleteProperties(endPoint, body, token): Observable<any[]> {
    //     // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
    //     return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Headers': 'Content-Type',
    //             'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
    //             'Access-Control-Allow-Origin': '*',
    //             'auth': token
    //         }
    //     })
    //         .pipe(tap(result => {
    //             result
    //         }),
    //             catchError(this.handleError('Response', []))
    //         );
    // }

    deleteSubscriberUser(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    uploadFile(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    createUpdateSubscriber(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getalltags(endPoint, token): Observable<any> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getallreportsruntoday(endPoint, body, token): Observable<any> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getallreportscounttoday(endPoint, body, token): Observable<any> {
        console.log(body);
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                Authorization: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // Function to add or update user
    updateRequestStatus(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    DeletePricingCriteria(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    getAllScreeningData(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    InsertScreeningCriteria(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    setScreeningCriteriaBySubscriber(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    setPricingCriteriaBySubscriber(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getPdf(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    downloadData(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update user
    deleteCredentialingData(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    createUpdateProperty(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    /**
 * This is common function to set token in localStorage to authenticate user at the time of navigation.
 * @param token -required token to set in localstorage.
 */
    setUserToken(token, refreshToken?) {
        // Always replaced, so a refresh token from an earlier sign-in can never renew this session as that account.
        if (refreshToken) {
            localStorage.setItem('refreshToken', refreshToken);
        } else {
            localStorage.removeItem('refreshToken');
        }
        if (token) {
            localStorage.setItem('token', token);
            this.authToken = token;
        } else {
            localStorage.setItem('token', '');
            this.authToken = token;
        }
    }

    // Renews the token in the last 5 minutes before it expires. Only a rejected refresh token or a
    // session with no refresh token goes to login; a network or server failure retries on the next tick.
    refreshTokenIfExpiring() {
        const isConsumer = sessionStorage.getItem('consumerLogin') != null;
        const token = localStorage.getItem('token');
        if (this.refreshingToken || !token || (!isConsumer && sessionStorage.getItem('userLogin') == null && sessionStorage.getItem('subscriberLogin') == null)) {
            return;
        }
        let exp = 0;
        try {
            exp = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp || Infinity;
        } catch (e) { }
        const msLeft = exp * 1000 - Date.now();
        if (msLeft > 300000) {
            return;
        }
        const goToLogin = () => {
            sessionStorage.clear();
            this.RemoveUserToken();
            window.location.hash = isConsumer ? '#/consumer/login' : '#/login';
            window.location.reload();
        };
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            if (msLeft <= 0) {
                goToLogin();
            }
            return;
        }
        this.refreshingToken = true;
        this.http.post<any>(environment.dataUrl + 'admin/user/refreshToken', { refreshToken }).subscribe(res => {
            this.refreshingToken = false;
            localStorage.setItem('token', res.Data.token);
            localStorage.setItem('refreshToken', res.Data.refreshToken);
        }, err => {
            this.refreshingToken = false;
            if (err.status === 401) {
                goToLogin();
            }
        });
    }

    /**
    * This is common function to get userdata which is set by setUserToken()
    */
    getUserToken() {
        const token = localStorage.getItem('token');
        this.authToken = token;
        return token;
    }

    RemoveUserToken() {
        const token = localStorage.getItem('token');
        if (token) {
            localStorage.removeItem('token');
        }
        localStorage.removeItem('refreshToken');
        const tokenScanner_export = localStorage.getItem('tokenScanner_export');
        if (tokenScanner_export) {
            localStorage.removeItem('tokenScanner_export');
        }
    }

    RemoveUserData() {
        const role = localStorage.getItem('role');
        if (role) {
            localStorage.removeItem('role');
        }
        const username = localStorage.getItem('username');
        if (username) {
            localStorage.removeItem('username');
        }
        const designMode = localStorage.getItem('designMode');
        if (designMode) {
            localStorage.removeItem('designMode');
        }
    }

    // Function to update user password
    updateUserPassword(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        const token = body.token;
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to update user password
    checkIfTokenHasExpired(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        const token = body.token;
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to login subscriber into the platform
    subscriberLogin(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    adminLogin(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    consumerLogin(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendEmailForForgotPassword(endPoint, body): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add or update credentialing

    addUpdateCredentialsForSubscriber(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token

            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to verify token
    verifyToken() {
        const userToken = this.getUserToken();
        if (!userToken) {
            return false;
        } else {
            return userToken;
        }
    }

    // getUserRole(endPoint, body, token): Observable<any[]> {
    //     // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
    //     return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Access-Control-Allow-Headers': 'Content-Type',
    //             'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
    //             'Access-Control-Allow-Origin': '*',
    //             'auth': token
    //         }
    //     })
    //         .pipe(tap(result => {
    //             result
    //         }),
    //             catchError(this.handleError('Response', []))
    //         );
    // }

    checkUserRole(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    deletealias(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to add Role
    addRole(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to get all roles
    getAllRoles(endPoint: any, body: any , token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to delete a role
    deleteRole(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to get permissions for perticular role
    getRolePermissions(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateRolePermissions(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getPaymentList(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getCounty(zipCode: string): Observable<any> {
      return this.http.get<any[]>(`${this.apiUrl}?postalcode=${zipCode}&country=US&format=json`)
        .pipe(
          map(response => response.length > 0 ? response[0] || 'County not found' : 'County not found')
        );
    }

    getEvictionFilesListPaged(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getCombosDetails(endPoint: any, token: any, body: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getelasticsearch(endPoint, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to get the credential data
    getCredentialData(endPoint, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getreportsAndServices(endPoint: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    createCombos(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getInvoiceDetails(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getConsolidatedInvoiceDetail(endPoint, body, token): Observable<any> {
        return this.http.post<any>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => { result; }),
                catchError(this.handleError('Response', []))
            );
    }

    updateCombos(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getCombosData(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to delete user
    deleteCombos(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getUserDataByID(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSubscriberDetailsByID(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateUserDataByID(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    orderReport(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    makeFinalPayment(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getPaymentSessionID(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    verifyOTP(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateSubscriberProfileByID(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSubscriberNames(endPoint, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getAllSubscriberCredentialDetails(endPoint, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    AllPropertiesForadmin(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllRequest(endPoint, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // http://192.168.3.212:9886//admin/request/getArchiveRecords?pageNum=1*pageSize=10
    getArchiveList(endPoint, token, data): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint + '?pageNum=' + data.pageNum + '&pageSize=' + data.pageSize, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getProperties(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllReportsList(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSubscriberAccessConfigData(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    addCoApplicants(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updatePreliminary(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    deleteProperties(endPoint, token): Observable<any[]> {
        return this.http.delete<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    addUpdateQualityAssurence(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendOtpAndInsertOtpDetails(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    checkIf2faEnabled(endPoint: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    disable2fa(endPoint: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    resendotp(endPoint: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, null, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    validateLogin(endPoint: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    // to get all sales representative
    getAllSales(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    // to get all adverse letter
    getAllAdverse(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    sendApplicantEmail(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateApplicantsStatus(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    verifySubscriber(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getDvId(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    printAdverseLetter(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getSaleDetails(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    addSale(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllAdminPaymentListPaged(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllTenantFeedbackPaged(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    UpdateSale(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    tenantSales(endPoint, body): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to delete a sale representative
    deleteSale(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getAllDataManagement(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getAllInspectionFormPaged(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getDataManagementDetails(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    addDataManagement(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    UpdateDataManagement(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Function to delete a Data Management
    deleteDataManagement(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    uploadConsumerFiles(endPoint, body): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    updateInspection(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token

            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getStateList(endPoint: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getCountryList(endPoint, body): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendDisclosureRequest(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendDisputeRequest(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getCPReuestDetails(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // to get all data management
    getAllDisclosureRequestPaged(endPoint: any, body: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    getAllDisclosureRequest(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    sendResponseAction(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getsalescommisionreport(endPoint: any, token: any): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    // to get all marketing
    getAllMarketingQueue(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    sendMarketingQueueMail(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // to get all credit limit details
    getManageCreditDetails(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    updateSubscriberReportStatus(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // update subscriber credit limit from admin
    updateSubscriberCreditLimit(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // to get Subscriber Wallet Details in subscriber
    getSubscriberWalletDetails(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    // to get Subscriber Wallet Details in subscriber
    getAdminWalletDetails(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    // to get all credit limit details
    getPropertiesOfSubscriber(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    updateSubscriberPropertiesWallet(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // add dnd list
    addDndList(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // to get all sales representative
    getAllDndList(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    sendEmailDisclosureAfterUplaoding(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    sendEmailDisclosure(endPoint, body, token): Observable<any[]> {
        // const token = this.dataservice.getUserToken() ? this.dataservice.getUserToken() : '';
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    getPlaintiffDetails(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendMarketingQueuePrint(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // to get all queued records in marketing
    getAllQueuedMarketingRecords(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    // send queued record to processed
    sendQueuedRecordsToProcess(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // to get all Notes List
    getAllNotesList(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    addQANote(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    // to get all QA List
    getAllQAList(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    addReleaseQANote(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getSendInvoiceList(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    sendInvoiceToPrint(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    sendInvoiceToEmail(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // update order in QA
    updateQAOrder(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }
    getEditOrderDetails(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }
    updateOrderAddress(endPoint, body, token): Observable<any[]> {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                auth: token,
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // download agreement
    downloadPdf(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/pdf',
                Accept: 'application/pdf',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            },
            responseType: 'blob' as 'json'
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    sendWelcomeEmailCall(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // common functions

    getDetails(endPoint: any, token: any): Observable<any[]> {
        return this.http.get<any[]>(environment.dataUrl + endPoint, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        }).pipe(tap(result => {
            result;
        }),
            catchError(this.handleError('Response', []))
        );
    }

    sendData(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Move In date api start
    submitMoveInDate(endPoint: any, body: any, token: any) {
        return this.http.post<any[]>(environment.dataUrl + endPoint, body, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
                'Access-Control-Allow-Origin': '*',
                auth: token
            }
        })
            .pipe(tap(result => {
                result;
            }),
                catchError(this.handleError('Response', []))
            );
    }

    // Move In date api end

    // System info data
     /**
 * This is common function to set token in localStorage to authenticate user at the time of navigation.
 * @param token -required token to set in localstorage.
 */
      setSystemData(token) {
        if (token) {
            localStorage.setItem('system', token);
            this.authToken = token;
        } else {
            localStorage.setItem('system', '');
            this.authToken = token;
        }
    }

    /**
    * This is common function to get userdata which is set by setUserToken()
    */
    getSystemData() {
        const token = localStorage.getItem('system');
        this.authToken = token;
        return token;
    }

    RemoveSystemData() {
        const token = localStorage.getItem('system');
        if (token) {
            localStorage.removeItem('system');
        }
        const tokenScanner_export = localStorage.getItem('tokenScanner_export');
        if (tokenScanner_export) {
            localStorage.removeItem('tokenScanner_export');
        }
    }

    public getIPAddress()
  {
    // return this.http.get("https://api.ipify.org/?format=json");
    return this.http.get('https://api.ipgeolocation.io/ipgeo?apiKey=b45e716dc89649408d0e8391e127f31a');
    // return {"ip":"106.193.146.54"}
  }
  public getLocation()
  {
    // return this.http.get("http://ip-api.com/json/114.143.194.238?fields=61439")
    // return this.http.get("https://ip-api.com/json/?fields=61439")
    return this.http.get('https://api.ipgeolocation.io/ipgeo?apiKey=b45e716dc89649408d0e8391e127f31a');

    // let json={"status":"success","country":"India","countryCode":"IN","region":"MH","regionName":"Maharashtra","city":"Pune","zip":"411006","lat":18.6161,"lon":73.7286,"timezone":"Asia/Kolkata","isp":"Tata Teleservices Maharashtra Ltd","org":"Tata Teleservices (Maharashtra) Ltd","as":"AS17762 Tata Teleservices Maharashtra Ltd","query":"114.143.194.238"};
    // return {"status":"success","country":"India","countryCode":"IN","region":"MH","regionName":"Maharashtra","city":"Pune","zip":"411006","lat":18.6161,"lon":73.7286,"timezone":"Asia/Kolkata","isp":"Tata Teleservices Maharashtra Ltd","org":"Tata Teleservices (Maharashtra) Ltd","as":"AS17762 Tata Teleservices Maharashtra Ltd","query":"114.143.194.238"};
  }

}

